// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import Box from '@mui/material/Box'
import AppButton from '../ui/AppButton'
import type { InAppLaneProgress } from '../../api/inappEsign'

/** "Partially signed — awaiting provider": the words under the button (role as the signer list names it). */
export function partiallySignedText(p: InAppLaneProgress): string {
  return `Partially signed — awaiting ${p.awaiting_role ?? 'the next signer'}`
}

/**
 * D-ESIGN-1 O3 (owner 2026-10-21) — an in-app enrollment form in process offers its signed-so-far copy as soon as
 * ONE signer has signed: every signature collected so far on its own line, as DocuSign shows earlier signatures.
 * Renders nothing until there is such a copy (the lane keeps its own "View form" button then).
 */
export default function SignedSoFarLane({ progress, busy, disabled, onOpen }: {
  progress: InAppLaneProgress | null | undefined
  busy: boolean
  disabled: boolean
  onOpen: (documentId: string) => void
}) {
  if (!progress?.partial_doc_id) return null
  const docId = progress.partial_doc_id
  return (
    <Box data-testid="signed-so-far" sx={{ mt: 0.5 }}>
      <AppButton variant="outlined" size="small" disabled={disabled} onClick={() => onOpen(docId)}
        title="The form with every signature collected so far on its line">
        {busy ? '…' : 'View signed document'}
      </AppButton>
      <Box sx={{ fontSize: 10.5, color: 'var(--color-text-mute)', mt: 0.25 }}>{partiallySignedText(progress)}</Box>
    </Box>
  )
}
